import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import { SITE, OUTLETS } from '../data/site';

export default function KontakPage() {
  return (
    <>
      <section className="bg-[#1F140E] grain relative text-[#FDFBF7]">
        <div className="relative z-10 mx-auto max-w-6xl px-5 py-14 sm:py-20">
          <Breadcrumbs items={[{ name: 'Kontak', path: '/kontak/' }]} />
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-6">
            Hubungi Kami
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#E8DCC9]">
            Kanal resmi kami adalah kunjungan langsung ke outlet dan pesan melalui Instagram. Untuk
            pesanan nasi box, acara, maupun pertanyaan seputar frozen food, silakan sapa kami di
            salah satu kanal berikut.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-5 py-14 sm:py-20 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight">
            Instagram Resmi
          </h2>
          <p className="mt-3 text-base leading-relaxed text-[#6E6259]">
            Cara tercepat menjangkau kami — termasuk untuk pesanan nasi box dalam jumlah besar.
          </p>
          <div className="mt-6 grid gap-4">
            <a
              data-testid="kontak-instagram-solo"
              href={SITE.instagram.solo}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between gap-4 rounded-lg border border-[#E2D3BE] bg-white p-6 hover:border-[#D9822B] hover:shadow-md transition-all group"
            >
              <div>
                <p className="font-semibold text-[#1A110B]">Solo — Outlet Utama & Sudirman Square</p>
                <p className="text-sm text-[#6E6259] mt-1">@ayamgorengwiduransolo</p>
              </div>
              <span aria-hidden="true" className="text-[#C84B27] group-hover:translate-x-1 transition-transform">→</span>
            </a>
            <a
              data-testid="kontak-instagram-bali"
              href={SITE.instagram.bali}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-between gap-4 rounded-lg border border-[#E2D3BE] bg-white p-6 hover:border-[#D9822B] hover:shadow-md transition-all group"
            >
              <div>
                <p className="font-semibold text-[#1A110B]">Denpasar, Bali — Jl. Imam Bonjol</p>
                <p className="text-sm text-[#6E6259] mt-1">@ayamwiduranbali</p>
              </div>
              <span aria-hidden="true" className="text-[#C84B27] group-hover:translate-x-1 transition-transform">→</span>
            </a>
          </div>
          <p className="mt-6 text-sm leading-relaxed text-[#6E6259]">
            Pertanyaan umum lainnya mungkin sudah terjawab di{' '}
            <Link to="/faq/" data-testid="kontak-link-faq" className="text-[#C84B27] font-semibold underline underline-offset-4 hover:text-[#a93d1f] transition-colors">
              halaman FAQ
            </Link>
            .
          </p>
        </div>

        <div className="lg:col-span-6">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-[#2B1B12] tracking-tight">
            Kunjungi Langsung
          </h2>
          <ul className="mt-6 space-y-5">
            {OUTLETS.map((o) => (
              <li key={o.id} className="rounded-lg bg-[#F5EFE6] border border-[#E2D3BE] p-6">
                <p className="font-pricemono text-[11px] tracking-widest uppercase text-[#C84B27]">{o.badge}</p>
                <h3 className="font-display text-xl font-semibold text-[#2B1B12] mt-1">{o.name}</h3>
                <address className="not-italic text-sm leading-relaxed text-[#6E6259] mt-2">{o.address}</address>
                <a
                  data-testid={`kontak-directions-${o.id}`}
                  href={o.maps}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-4 inline-flex items-center text-sm font-semibold text-[#C84B27] hover:text-[#a93d1f] transition-colors"
                >
                  Buka di Google Maps <span aria-hidden="true" className="ml-1.5">→</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
}
